export enum MESSAGE_TEMPLATE_TYPE {
  CONSULT = '유선상담용',
  ONLINE_MEETING = '미팅용',
  OFFLINE_MEETING = '대면미팅용',
}

export const CONST_MESSAGE_TEMPLATE_TYPE = Object.values(MESSAGE_TEMPLATE_TYPE);
